import styled from 'styled-components';

export const TableHeadRoot = styled.thead`
    display: table-header-group;
`;
